import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CustomerExtendedDetails from "./CustomerExtendedDetails";
import CustomerHeader from "@View/pages/AdminPO/customer/customerDetails/common/CustomerHeader";

const CustomerDetailsPage = () => {
  const { id: customerId } = useParams();
  const customer = useSelector((state) => state.customer.customer);

  return (
    <div className="customerDetails__page">
      <CustomerHeader customerId={customerId} />
      {customer &&
        typeof customer === "object" &&
        Object.keys(customer).length > 0 && (
          <CustomerExtendedDetails customer={customer} />
        )}
    </div>
  );
};

export default CustomerDetailsPage;
